export const admissions = {
  title: "Proceso de Admisión",
  subtitle: "Te acompañamos en cada paso del camino hacia formar parte de nuestra comunidad educativa",
  process: {
    title: "Pasos para unirte a Gándara",
    steps: [
      {
        title: "Contacto inicial",
        description: "Ponte en contacto con nosotros por teléfono, email o a través de nuestra página web para expresar tu interés."
      },
      {
        title: "Visita guiada",
        description: "Reserva una visita para conocer nuestras instalaciones, metodología y equipo educativo. Podrás resolver todas tus dudas."
      },
      {
        title: "Solicitud de admisión",
        description: "Completa el formulario de solicitud con la información de tu hijo/a y familia."
      },
      {
        title: "Entrevista familiar",
        description: "Tendremos una conversación con la familia para conoceros mejor y asegurar que compartimos valores y expectativas."
      },
      {
        title: "Confirmación y matrícula",
        description: "Si hay plazas disponibles y ambas partes están de acuerdo, procederemos con la formalización de la matrícula."
      }
    ]
  },
  requirements: {
    title: "Documentación necesaria",
    items: [
      "Formulario de inscripción completo",
      "Fotocopia del DNI/Pasaporte del alumno/a",
      "Fotocopia del DNI de los padres/tutores",
      "Certificado de nacimiento",
      "Certificado médico actualizado",
      "Fotografía reciente tamaño carnet",
      "Justificante del pago de matrícula"
    ]
  },
  visit: {
    title: "Reserva tu visita",
    description: "El primer paso es conocernos. Agenda una visita para descubrir Gándara.",
    button: "Agendar visita"
  },
  contact: {
    title: "¿Tienes dudas?",
    description: "Estamos aquí para ayudarte. Contacta con nosotros y resolveremos todas tus preguntas.",
    button: "Contactar"
  }
};
